// Class: haxe.iterators.StringIterator

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;
var $import = require("./../../import_stub").default;
function StringTools() {return require("./../../StringTools");}

// Constructor

var StringIterator = function(s) {
	this.offset = 0;
	this.s = s;
}

// Meta

StringIterator.__name__ = "haxe.iterators.StringIterator";
StringIterator.__isInterface__ = false;
StringIterator.prototype = {
	hasNext: function() {
		return this.offset < this.s.length;
	},
	next: function() {
		return (StringTools().default).fastCodeAt(this.s,this.offset++);
	}
};
StringIterator.prototype.__class__ = StringIterator.prototype.constructor = $hxClasses["haxe.iterators.StringIterator"] = StringIterator;

// Init



// Statics




// Export

exports.default = StringIterator;